/**
 * Variant selector component
 *
 * @module variant-selector
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = "variant-selector";

if (!customElements.get(customElements.component)) {
  class VariantSelector extends HTMLElement {
    /**
     * Variant selector web component
     *
     * @constructor
     */
    constructor() {
      super();

      window.theme.product
        .loadProduct(this.dataset.handle, true)
        .then((product) => {
          this.render(product);
        });
    }

    // /**
    //  * Init component events
    //  *
    //  * @param {object} product Product data.
    //  * @returns {undefined}
    //  */
    // initEvents(product) {
    //   let selects = this.querySelectorAll("select");

    //   selects.forEach((select) => {
    //     if (select) {
    //       // Trigger event on it to select the first variant available
    //       this.triggerVariantChange(select.value, product);

    //       select.addEventListener("change", (event) => {
    //         this.triggerVariantChange(event.target.value, product);
    //       });
    //     }
    //   });
    // }

    /**
     * Initialize component events.
     *
     * @param {object} product Product data.
     */
    initEvents(product) {
      let selects = this.querySelectorAll("select");

      selects.forEach((select) => {
        if (select) {
          const variantIdFromURL = this.getVariantIdFromURL();
          if (variantIdFromURL) {
            this.selectVariantById(variantIdFromURL);
            this.triggerVariantChange(variantIdFromURL, product);

          } else {
            // If no variant ID in the URL, use the current behavior
            this.triggerVariantChange(select.value, product);
          }

          select.addEventListener("change", (event) => {
            this.triggerVariantChange(event.target.value, product);
          });
        }
      });
    }


    /**
     * Render component in the DOM
     *
     * @param {object} product Product data.
     * @returns {undefined}
     */
    render(product) {
      if (this.getTemplate()) {
        let html = this.getTemplate();

        // Load options

        let options = "";

        // TODO: We need to improve this code to remove or hide the dependency of the swatch terms.
        product.variants.forEach((variant) => {
          let reference = "";

          product.options.forEach((option, index) => {
            // We are using this data to handle out of stock swatches
            reference =
              reference +
              ` data-swatches-option-${option.name.replace(
                / /g,
                "-"
              )}="${variant.options[index]
                .replace(/ /g, "-")
                .replaceAll('"', "")}"`;
          });

          if (variant.available) {
            options =
              options +
              `<option data-variant-id="${variant.id}" ${reference} value="${variant.id}" data-enabled>${variant.title}</option>`;
          } else {
            options =
              options +
              `<option data-variant-id="${variant.id}" ${reference} value="${variant.id}" data-disabled>${variant.title} - Sold Out</option>`;
          }
        });

        html = html.replace(/{{options}}/g, options);

        // Inject HTML
        this.innerHTML = html;

        this.initEvents(product);
        this.triggerRender(product);
      }
    }

    /**
     * Get component template
     *
     * @returns {string} Component HTML template.
     */
    getTemplate() {
      return window.theme.variantSelector.template
        ? window.theme.variantSelector.template
        : "";
    }

    /**
     * Extracts the variant ID from the URL.
     *
     * @returns {string|null} The variant ID if it exists, otherwise null.
     */
    getVariantIdFromURL() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('variant');
    }

    /**
     * Pre-selects the option in the dropdown based on the provided variant ID.
     *
     * @param {string} variantId The variant ID to select.
     */
    selectVariantById(variantId) {
      if (!variantId) return;

      const selectElement = this.querySelector(`select option[data-variant-id="${variantId}"]`);
      if (selectElement) {
        selectElement.selected = true;
      }
    }


    /**
     * Trigger render
     *
     * @param {object} product Product data.
     * @returns {object} Event Trigger ready.
     */
    triggerRender(product) {
      this.classList.add("ready");

      let event = new CustomEvent("ready", {
        detail: {
          product: product,
        },
      });

      this.dispatchEvent(event);

      return event;
    }

    /**
     * Trigger variant change with data
     *
     * @public
     * @method
     * @name triggerVariantChange
     * @param {integer} variantId Variant id.
     * @param {object} product Product data.
     * @fires variant-change
     * @returns {object} Event variant-change.
     */
    triggerVariantChange(variantId, product) {
      let event = new CustomEvent("variant-change", {
        detail: {
          variantId: variantId,
          variant: window.theme.product.getVariant(variantId, product),
          product: product,
        },
      });

      window.dispatchEvent(event);

      // let accordion_content = document.querySelector('#accordion__content__2445');
      // accordion_content.style.maxHeight = accordion_content.scrollHeight + 30 + "px";
      // console.log(accordion_content + 'height set to ' + accordion_content.scrollHeight + "+" + 30 + "px");

      // This sets the variant ID in the url -> doesn't solve the problem -> linking resets
      // window.history.replaceState({ }, '', `${this.dataset.handle}?variant=${variantId}`);

      return event;
    }
  }

  customElements.define(customElements.component, VariantSelector);
}
